import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { graphql } from 'gatsby';

import * as Sentry from '@sentry/gatsby';
import useStrapiPageData from '../hooks/data/useStrapiPageData';
import useTransformGatsbyData from '../hooks/useTransformGatsbyData';

import useNavigation from '../hooks/useNavigation';
import useSearch from '../hooks/useSearch';
import useWithGA from '../hooks/useWithGA';

import MetatagsForLayout from '../components/MetatagsForLayout';

import { PAGE_INDEX, PAGE_FOUR_O_FOUR } from '../constants/strapi';
import { NotFound } from '../ui/templates/notFound/NotFound';

export const pageQuery = graphql`
  query FourOFourPage($pageBuildId: String!) {
    bwPageBuildData(id: { eq: $pageBuildId }) {
      data
    }
  }
`;

const NotFoundPage = ({ data, location }) => {
  const bwPageBuildData = useTransformGatsbyData(data.bwPageBuildData);
  const { siteUrls } = bwPageBuildData.pageData;

  const { t } = useTranslation();
  const { menu, footer } = useNavigation(siteUrls, location);
  const search = useSearch();
  const { savePageView } = useWithGA();

  const [indexPageUrl] = useStrapiPageData(PAGE_INDEX);

  useEffect(() => {
    savePageView({
      type: '404',
    });
    Sentry.captureMessage('404 page');
  }, []);

  return (
    <NotFound
      hero={{
        title: t('common.404Title'),
        description: t('common.404Text'),
        homeLinkUrl: indexPageUrl,
        homeLinkText: t('common.toStartpage'),
      }}
      menu={menu}
      footer={footer}
      siteUrls={siteUrls}
      location={location}
      search={search}
      t={t}
    />
  );
};

NotFoundPage.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
};

export default NotFoundPage;

export function Head({ data, location, pageContext }) {
  const { locale } = pageContext;
  const fourOFourPageData = useStrapiPageData(PAGE_FOUR_O_FOUR)[1];
  const { seo } = fourOFourPageData;

  const bwPageBuildData = useTransformGatsbyData(data.bwPageBuildData);
  const { siteUrls } = bwPageBuildData.pageData;

  return (
    <MetatagsForLayout
      title={seo.metaTitle}
      description={seo.metaDescription}
      pathname={location.pathname}
      locale={locale}
      siteUrls={siteUrls}
    />
  );
}
